import React, { useEffect, useRef } from 'react';
import useEditOrderContext from '../hooks/useEditOrderContext';

import type Client from 'App/resources/Model/Client';
import type { ComponentProps } from 'react';
import type { EditOrderClient } from '../types';

type Props = Omit<ComponentProps<typeof ReactTemplates.INPUTS.upAccounts>, 'value' | 'onChange'> & {
	value: EditOrderClient | null;
	onChange: (item: EditOrderClient) => void;
};

const AccountSelect = ({ name, required, onChange: _onChange, value, ...props }: Props) => {
	const { registerFormComponent, unregisterFormComponent, onFormConponentChange } = useEditOrderContext();
	const lastCommittedValueRef = useRef<EditOrderClient | null>(value);

	useEffect(() => {
		if (name) {
			const valid = required ? !!value : true;
			registerFormComponent(name, valid);
			return () => unregisterFormComponent(name);
		}
		// Will not add name to the dependency array because then I need something like renameControl
	}, []);

	useEffect(() => {
		if (value !== lastCommittedValueRef.current) {
			if (name) {
				const valid = required ? !!value : true;
				onFormConponentChange(name, valid, false);
			}
		}
	}, [value]);

	function onChange(_value: Client) {
		const value = (lastCommittedValueRef.current = _value as EditOrderClient);

		_onChange?.(value);

		if (name) {
			const valid = required ? !!value : true;
			onFormConponentChange(name, valid, true);
		}
	}

	return (
		<ReactTemplates.INPUTS.upAccounts
			{...props}
			name={name}
			value={value}
			onChange={onChange}
			required={required}
		/>
	);
};

export default AccountSelect;
